import React from 'react'
import RegisterOrganization from 'src/app/RegisterOrganization/RegisterOrganization'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { registerOrganizationRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const RegisterOrganizationAppRoute: AppRoute = {
  id: AppLocation.RegisterOrganization,
  routeProps: registerOrganizationRouteProps,
  component: <RegisterOrganization />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default RegisterOrganizationAppRoute
